
import { computed, defineComponent, toRefs } from 'vue';

import { Step, useStepperNavigation, useStepSkipper } from '@/components/wizard';
import { useCalculations } from '@/lib/calculationstate';

import Button from '@/components/Button.vue';
import Slider from '@/components/Slider.vue';
import { format } from '@/lib/currency';

export default defineComponent({
  name: 'Work',
  components: {
    Step,
    Button,
    Slider,
  },
  props: {
    step: { type: Number, required: true },
  },
  data() {
    return {
      currentlyWorking: false,
    };
  },
  computed: {
    title(): string {
      return this.currentlyWorking ? 'Hoeveel verdient u met het werk dat u nu doet?' : 'Werkt u op dit moment?';
    },
  },
  setup(props) {
    const { step } = toRefs(props);
    const {
      hasHighDisability,
      grossMonthlySalary,
      extraMonthlyIncome,
    } = useCalculations();
    const nav = useStepperNavigation(step);

    useStepSkipper(step, () => hasHighDisability.value);
    const formattedIncome = computed(() => format(extraMonthlyIncome.value));
    return {
      ...nav,
      grossMonthlySalary,
      formattedIncome,
      extraMonthlyIncome,
    };
  },
});
